// Pure helpers for the reusable Programme Roadmap editor.
export const uid = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID()
    : `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const CRIT_KEYS = ["entry", "progression", "regression", "stop_review"];
export const CRIT_LABELS = {
  entry: "Move into this phase when",
  progression: "Progress when",
  regression: "Step back if",
  stop_review: "Stop / seek review if",
};

export const BLOCK_META = {
  exercise: { label: "Exercise", icon: "Dumbbell" },
  education: { label: "Education", icon: "BookOpen" },
  resource: { label: "Resource", icon: "Link2" },
  evidence: { label: "Evidence / reference", icon: "FileText" },
  custom_text: { label: "Note / custom text", icon: "Type" },
};

export const LIST = (v) => (v || []).map((x) => (typeof x === "string" ? x : x.label || "")).join("\n");
export const SPLIT = (s) => (s || "").split("\n").map((x) => x.trim()).filter(Boolean);
// criteria stored as [{label}]; edit via one-per-line text
export const critFromText = (s) => SPLIT(s).map((label) => ({ label }));

export function emptyPhase(n) {
  return {
    id: uid(), title: `Phase ${n}`, description: "", goals: [],
    criteria: { entry: [], progression: [], regression: [], stop_review: [] },
    content_blocks: [],
  };
}

export function newBlock(type) {
  const data = {
    exercise: {
      exercise_id: "", sets: "", reps: "", rest_seconds: null, frequency_per_week: null,
      duration_seconds: null, load_guidance: "", tempo: "", instructions: "", side: "", notes: "",
      easier_alternative_id: "", harder_alternative_id: "", home_alternative_id: "",
    },
    education: { mode: "inline", text: "", source_type: "cms_resource", source_id: "" },
    resource: { source_type: "website", url: "", description: "", authors: "", publication: "", year: "", doi: "", clinician_note: "" },
    evidence: { authors: "", publication: "", year: "", doi: "", url: "", clinician_note: "" },
    custom_text: { text: "" },
  }[type] || {};
  return { id: uid(), type, title: "", order: 0, visibility: "patient", data };
}

export function move(arr, idx, dir) {
  const to = idx + dir;
  if (to < 0 || to >= arr.length) return arr;
  const next = [...arr];
  const [m] = next.splice(idx, 1);
  next.splice(to, 0, m);
  return next;
}

export function duplicateWithFreshIds(block) {
  return { ...block, id: uid(), data: { ...(block.data || {}) } };
}
